import { Root } from "../../../app/stores/store-root";
import {FormBehavior, FormBehaviourRules} from "./order-form-behaviour";
import { Order } from "../../../app/models/order";
import {status} from './order-form-behaviour';

export const OrderFormActions = {
    Empty:
        {
            value: '',
            text: 'Select an action'
        }
    ,
    Approve: {
        value: 'Approve',
        text: 'Approve Order'
    }
    ,
    Reject: {
        value: 'Rejected',
        text: 'Reject Order'
    }
    ,
    Cancel: {
        value: 'Cancelled',
        text: 'Cancel Order'
    }
    ,
    Pay: {
        value: 'Paid',
        text: 'Close as Paid'
    }
    ,
    InProgress: {
        value: 'InProgress',
        text: 'Set as In Progress'
    }
    ,
    Save: {
        value: 'Updated',
        text: 'Save changes'
    }

}
export const GetActionsForOrderStatus = (order: Order, store:Root):any[] => {
    for (var rule of OrderActionsRules) {
        if (rule.match(order, store))
            return rule.action();
    }
    return [];
}


export const OrderActionsRules=[
    //Admin Rules
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'PendingReview')
        },
        action: (): any[] => {
            return [OrderFormActions.Empty, OrderFormActions.Approve, OrderFormActions.Reject]
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'ReadyForCollection')
        },
        action: (): any[] => {
            return [OrderFormActions.Empty, OrderFormActions.Pay, OrderFormActions.Cancel, OrderFormActions.InProgress, OrderFormActions.Save]
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'Rejected')
        },
        action: (): any[] => {
            return [];}
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'Cancelled')
        },
        action: (): [] => {
            return []
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'Paid')
        },
        action: (): [] => {
            return []
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'InProgress')
        },
        action: (): any[] => {
            return [OrderFormActions.Empty, OrderFormActions.Pay, OrderFormActions.Cancel, OrderFormActions.InProgress, OrderFormActions.Save]
        }
    },

    //Sending Agent Rules
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'PendingReview')
        },
        action: (): any[] => {
            return[OrderFormActions.Empty, OrderFormActions.Cancel] }

    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'ReadyForCollection')
        },
        action: (): any[] => {
            return [];
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'Rejected')
        },
        action: (): any[] => {
            return []
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'Cancelled')
        },
        action: (): [] => {
            return [];
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'Paid')
        },
        action: (): [] => {
            return [];
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'InProgress')
        },
        action: (): [] => {
            return []
        }
    },

    //Receiving Agent Rules
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'PendingReview')
        },
        action: (): [] => {
            return []
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'ReadyForCollection' && ((order.DeliveryOffice!=null && order.DeliveryOffice==='Asmara')||(order.DeliveryType==='0')))
        },
        action: (): any[] => {
            return [OrderFormActions.Empty, OrderFormActions.Pay, OrderFormActions.Cancel]
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'ReadyForCollection' && (order.DeliveryOffice!=null && order.DeliveryOffice!=='Asmara'))
        },
        action: (): any[] => {
            return [OrderFormActions.Empty, OrderFormActions.Cancel, OrderFormActions.InProgress]
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isCashier) && status(order.Status) === 'ReadyForCollection' && (order.DeliveryOffice!=null && order.DeliveryOffice!=='Asmara'))
        },
        action: (): any[] => {
            return [OrderFormActions.Empty, OrderFormActions.InProgress]
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'Rejected')
        },
        action: (): any[] => {
            return [];
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'Cancelled')
        },
        action: (): any[] => {
            return [];
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'Paid')
        },
        action: (): [] => {
            return [];}

    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'InProgress')
        },
        action: (): any[] => {
            return [OrderFormActions.Empty, OrderFormActions.Pay, OrderFormActions.Save]}

    }
]
